.resultBlock {
  padding-bottom: var(--mantine-spacing-md);
  border-bottom: 1px solid var(--mantine-color-gray-3);
}

.resultBlock:last-of-type {
  border-bottom: none;
  padding-bottom: 0;
}
